export class UtmComponent {
  paramNames = [
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_term',
    'utm_content'
  ];

  params;

  constructor() {
    this.params = typeof THEME_CONFIG !== 'undefined' && THEME_CONFIG.hasOwnProperty('utm_params') ? THEME_CONFIG.utm_params : [];
  }

  initialize() {
    this.setFormInputs();
  }

  setFormInputs() {
    this.paramNames.forEach((name) => {
      let inputs = document.querySelectorAll(`input[name=${name}]`);
      [...inputs].forEach((input) => {
        let value = this.getParamByName(name);
        if (value) {
          input.value = value;
        }
      });
    });
  }

  getParamByName(name) {
    return this.params.hasOwnProperty(name) ? this.params[name] : '';
  }
}